import { createReducer, on } from '@ngrx/store';
import {
  loadCollection,
  loadCollectionFailure,
  loadCollectionSuccess,
  sendAnswer,
  sendAnswerFailure,
  sendAnswerSuccess
} from '../actions/surveys.actions';
import {
  SurveyBaseAllBaseReadSurveyAllSurveyRead
} from '../../openapi';

export interface SurveysState {
  loading: number;
  pending: number;
  collection: SurveyBaseAllBaseReadSurveyAllSurveyRead[];
}

export const surveysInitialState: SurveysState = {
  pending: 0,
  loading: 0,
  collection: []
};

export const surveyReducer = createReducer(
  surveysInitialState,
  on(loadCollection, state => ({ ...state, loading: state.loading + 1 })),
  on(loadCollectionSuccess, (state, action) => ({
    ...state,
    loading: state.loading - 1,
    collection: action.collection
  })),
  on(loadCollectionFailure, (state) => ({ ...state, loading: state.loading - 1 })),
  on(sendAnswer, state => ({ ...state, pending: state.pending + 1 })),
  on(sendAnswerSuccess, state => ({ ...state, pending: state.pending - 1 })),
  on(sendAnswerFailure, state => ({ ...state, pending: state.pending - 1 }))
);
